import { useQuery, UseQueryOptions, QueryKey } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TASKASSIGNMENT_STATUS_COUNTS } from "./apiRoutes";

// Response structure from Swagger
export interface PriorityCount {
  priority: string;
  count: number;
}

export interface TaskStatusCount {
  taskStatus: string;
  total: number;
  priorities: PriorityCount[];
}

export interface TaskStatusCountsResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: TaskStatusCount[];
  message: string;
}

const fetchTaskStatusCounts = async (): Promise<TaskStatusCountsResponse> => {
  const response = await axiosAuth.get<TaskStatusCountsResponse>(
    TASKASSIGNMENT_STATUS_COUNTS
  );
  return response.data;
};

export const useGetTaskStatusCountsQuery = (
  options?: Omit<
    UseQueryOptions<TaskStatusCountsResponse, Error, TaskStatusCountsResponse, QueryKey>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["taskStatusCounts"],
    queryFn: fetchTaskStatusCounts,
    ...options,
  });
};
